export default __webpack_public_path__ + "static/personal-loan-graphic-7a76d877a7c98af0b5088905e098cfc9.svg";